import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
  Toolbar,
} from "devextreme-react/data-grid";
import { RequiredRule, SimpleItem } from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import CustomStore from "devextreme/data/custom_store";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function CertificateOfQualification() {
  const [dataSource, setDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/certificateOfQualification/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/certificateOfQualification/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/certificateOfQualification/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/certificateOfQualification/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );
  }, []);

  const calculateDisplayValue = (data) => {
    return `${data.title}${data.org ? `, ` + data.org : ``}`;
  };

  return (
    <React.Fragment>
      <DataGrid
        id="certificateOfQualificationGrid"
        dataSource={dataSource}
        keyExpr="SEQ"
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        allowColumnReordering={true}
        style={{
          maxHeight: "calc(100vh - 180px)",
          marginLeft: "10px",
          marginRight: "10px",
          // marginTop: "56px",
        }}
        hoverStateEnabled={true}
        showColumnHeaders={false}
      >
        <LoadPanel enabled={true} />

        <SearchPanel visible={true} />

        <Scrolling mode={"virtual"} showScrollbar={"always"} />

        <Selection mode={"single"} />

        <Editing
          mode={"popup"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          <Texts
            confirmDeleteTitle={"Delete the Certificate of Qualification"}
            confirmDeleteMessage={
              "Are you sure you want to delete this certificate of qualification?"
            }
          />
          <Popup
            title={"Certificate of Qualification"}
            showTitle={true}
            height={200}
          />
          <Form
            labelMode={"outside"}
            showColonAfterLabel={false}
            labelLocation="top"
            minColWidth={300}
            colCount={2}
            colCountByScreen={{ sm: 2, md: 4 }}
            screenByWidth={(width) => {
              return width < 720 ? "sm" : "md";
            }}
            validationGroup="certificateOfQualification"
            height={"100%"}
          >
            <SimpleItem dataField={"title"} colSpan={2}>
              <RequiredRule message={"* Title을 입력해주세요."} />
            </SimpleItem>
            <SimpleItem dataField={"org"}></SimpleItem>
            <SimpleItem
              dataField={"date"}
              editorType="dxDateBox"
              editorOptions={{
                type: "date",
                displayFormat: "yyyy-MM-dd",
                dateSerializationFormat: "yyyy-MM-dd",
                showClearButton: true,
                max: new Date(),
              }}
            >
              <RequiredRule message={"* Date를 입력해주세요."} />
            </SimpleItem>
          </Form>
        </Editing>

        <Column
          dataField={"title"}
          caption="Title"
          calculateDisplayValue={calculateDisplayValue}
        />
        <Column dataField={"org"} caption="Organization" visible={false} />
        <Column
          dataField={"date"}
          caption="Date"
          dataType={"date"}
          format="yyyy-MM-dd"
        />

        <Toolbar>
          <Item location="before">
            <span
              style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
            >
              CERTIFICATE OF QUALIFICATION
            </span>
          </Item>
          <Item location="after" name="addRowButton" />
          <Item location="after" name="searchPanel" />
        </Toolbar>
      </DataGrid>
    </React.Fragment>
  );
}
